// Copyright (C) 2021 Bystronic Laser AG

export enum CareAlertType {
  /**
   * Alert created directly on a device to be used as personalized alert to
   * fulfil user needs.
   */
  Custom = 1,

  /**
   * Alert created on a device from a standard alert definition.
   */
  Preset = 2,
}
